import { TabPane, Form } from 'reactstrap';
import PropTypes from 'prop-types';
import '../../../helpers/datePickerConfig';
import useDatosEscolares from './hooks/useDatosEscolares';
import ModalesDatosEscolares from './ModalesDatosEscolares';
import SeccionIdiomaSede from './SeccionIdiomaSede';
import SeccionSituacionLaboral from './SeccionSituacionLaboral';
import SeccionNotaMediaFechas from './SeccionNotaMediaFechas';
import SeccionEstudiosNee from './SeccionEstudiosNee';
import FormActionsDatosEscolares from './FormActions';

const DatosEscolares = ({
  prevActiveTab,
  datosEscolares,
  missingDataFunction,
  userId,
  datosPersonales,
}) => {
  const {
    formik,
    userOU,
    idCedesca,
    idCntec,
    formationCenter,
    academicFormation,
    studiesList,
    studiesList2,
    sitLaboralList,
    lastStudiesList,
    yearsApi,
    nese,
    isModalShown,
    isModalShown2,
    raw,
    url,
    setIsModalShown2,
    handleFechaTitulos,
  } = useDatosEscolares({
    prevActiveTab,
    datosEscolares,
    missingDataFunction,
    userId,
    datosPersonales,
  });

  return (
    <>
      <ModalesDatosEscolares
        isModalShown={isModalShown}
        isModalShown2={isModalShown2}
        url={url}
        raw={raw}
        setIsModalShown2={setIsModalShown2}
      />
      <TabPane tabId="2">
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit();
          }}
        >
          <SeccionIdiomaSede
            formik={formik}
            formationCenter={formationCenter}
            userOU={userOU}
            idCedesca={idCedesca}
            idCntec={idCntec}
          />
          <SeccionSituacionLaboral
            formik={formik}
            sitLaboralList={sitLaboralList}
            academicFormation={academicFormation}
            studiesList2={studiesList2}
            userOU={userOU}
          />
          <SeccionNotaMediaFechas
            formik={formik}
            yearsApi={yearsApi}
            handleFechaTitulos={handleFechaTitulos}
            userOU={userOU}
            idCedesca={idCedesca}
            idCntec={idCntec}
          />
          <SeccionEstudiosNee
            formik={formik}
            studiesList={studiesList}
            lastStudiesList={lastStudiesList}
            nese={nese}
            userOU={userOU}
          />
          <FormActionsDatosEscolares userOU={userOU} />
        </Form>
      </TabPane>
    </>
  );
};

DatosEscolares.propTypes = {
  prevActiveTab: PropTypes.string,
  datosEscolares: PropTypes.object,
  missingDataFunction: PropTypes.func,
  datosPersonales: PropTypes.object,
  userId: PropTypes.string,
};

export default DatosEscolares;
